import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=2d3bcd87&scoped=true"
import script from "./ArticleForm.vue?vue&type=script&lang=js"
export * from "./ArticleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3bcd87",
  null
  
)

export default component.exports